import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpClientJsonpModule, HTTP_INTERCEPTORS} from "@angular/common/http";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import { AppComponent } from './app.component';
import { AgmCoreModule } from '@agm/core';
import { MapComponent } from './map/map.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { RequestCache } from './http-interceptors/RequestCache';
import { CacheInterceptor } from './http-interceptors/CacheInterceptor';
import { ApiInterceptor } from './http-interceptors/ApiInterceptor';
import { environment } from '../environments/environment';
import { SearchComponent } from './search/search.component';
import { LocationResultsComponent } from './location-results/location-results.component';
import { LocationFilterComponent } from './location-filter/location-filter.component';
import { LocationInfoComponent } from './location-info/location-info.component';
import { AvailableProductsComponent } from './available-products/available-products.component';
import { FilterProductsComponent } from './filter-products/filter-products.component';
import { StoreResultsComponent } from './store-results/store-results.component';
import { ProductResultsComponent } from './product-results/product-results.component';
import { ProductLocationsComponent } from './product-locations/product-locations.component';
import { LocationRoutesComponent } from './location-routes/location-routes.component';
import { HintComponent } from './hint/hint.component';
import { LoginComponent } from './login/login.component';
import { UserMenuComponent } from './user-menu/user-menu.component';
import { ProductFilterPipe } from './filters/product-filter.pipe';
import { NurseriesFilterPipe } from './filters/nurseries-filter.pipe';
import { SortByPipePipe } from './filters/sort-by-pipe.pipe';
import { FiltersPipePipe } from './filters/filters-pipe.pipe';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { OrderByDistancePipe } from './filters/order-by-distance.pipe';
import { OrderByMembershipPipe } from './filters/order-by-membership';
import { MetersAsMilesPipe } from './filters/metersAsMiles.pipe'
import { ExampleComponent } from './example/example.component';
import { ResultsComponent } from './results/results.component';
import { NurseriesComponent } from './nurseries/nurseries.component';
import { NurseryListComponent } from './nurseries/result/nursery-list.component';
import { NurseryFilterComponent } from './nurseries/filter/nursery-filter.component';
import { NurseryProductsComponent } from './nursery-products/nursery-products.component';
import { ProductCardComponent } from './product-card/product-card.component';
import { NurseryCardComponent } from './nursery-card/nursery-card.component';
import { PlantsComponent } from './plants/plants.component';
import { PlantListComponent } from './plants/result/plant-list.component';
import { PlantFilterComponent } from './plants/filter/plant-filter.component';
import { PaginationComponent } from './pagination/pagination.component';
import { PollinatorComponent } from './pollinators/pollinators.component';

import { LocationService } from './services/location.service';
import { StatesService } from './services/states.service';
import { StatesService as OldStatesService } from './services/states.service.old';
import { LoginService } from './services/login.service';
import { NurseryService } from './services/nursery.service';
import { NurseryService as OldNurseryService } from './services/nursery.service.old';
import { ContainerSizeFilter } from './filters/container-size-filter.pipe';
import { PackagingFilter } from './filters/packaging-filter.pipe';
import { PlantService } from './services/plant.service';
import { PollinatorService } from './services/pollinator.service';

import { ModalModule } from 'ngx-bootstrap/modal';
import { AppRoutingModule } from './app.routing.module';

@NgModule({
  declarations: [
    AppComponent,
    MapComponent,
    SearchComponent,
    LocationResultsComponent,
    LocationFilterComponent,
    LocationInfoComponent,
    AvailableProductsComponent,
    FilterProductsComponent,
    StoreResultsComponent,
    ProductResultsComponent,
    ProductLocationsComponent,
    LocationRoutesComponent,
    HintComponent,
    LoginComponent,
    UserMenuComponent,
    ProductFilterPipe,
    NurseriesFilterPipe,
    SortByPipePipe,
    FiltersPipePipe,
    LandingPageComponent,
    OrderByDistancePipe,
    MetersAsMilesPipe,
    ExampleComponent,
    ResultsComponent,
    ContainerSizeFilter,
    PackagingFilter,
    OrderByMembershipPipe,
    NurseriesComponent,
    NurseryFilterComponent,
    NurseryListComponent,
    NurseryProductsComponent,
    ProductCardComponent,
    NurseryCardComponent,
    PlantsComponent,
    PlantListComponent,
    PlantFilterComponent,
    PaginationComponent,
    PollinatorComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    FontAwesomeModule,
    HttpClientModule,
    HttpClientJsonpModule,
    BrowserAnimationsModule,
    AgmCoreModule.forRoot({
      apiKey: environment.GOOGLE_MAPS_API_KEY
    }),
    ModalModule.forRoot(),
    AppRoutingModule
  ],
  providers: [
    RequestCache,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CacheInterceptor,
      multi: true
    },
    StatesService,
    LocationService,
    LoginService,
    NurseryService,
    OldNurseryService,
    OldStatesService,
    PlantService,
    PollinatorService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
